import { render, staticRenderFns } from "./admin-parameters.vue?vue&type=template&id=adf472f2"
import script from "./admin-parameters.vue?vue&type=script&lang=js"
export * from "./admin-parameters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports